import {
	EverplansEmailStatusEnum,
	type SubmissionAction,
} from '@/classes/SubmissionStatuses/types'
import FixOrUpgradeModalContent, {
	type FixOrUpgradeProps,
} from '@/components/home/SubmissionStatuses/ResubmissionModals/FixOrUpgradeModalContent.vue'

export default class FixOrUpgradeAction implements SubmissionAction {
	buttonText: string
	component = FixOrUpgradeModalContent
	componentProps: Omit<FixOrUpgradeProps, 'planId'>

	constructor(
		emailErrorStatus: EverplansEmailStatusEnum,
		requestedAccountTier?: string | null,
		lastSubmittedEmail?: string | null,
		purchaseAmount?: string,
		buttonText: string = 'Fix'
	) {
		this.componentProps = {
			emailErrorStatus,
			requestedAccountTier,
			purchaseAmount: purchaseAmount ? Number(purchaseAmount) : undefined,
			lastSubmittedEmail,
		}
		this.buttonText = buttonText
	}
}
